import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    type: '25px',
    value: 0,
  },
};

export const spacerSlice = createSlice({
  name: 'spacer',
  initialState,
  reducers: {
    spacerStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent } = block;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.blockContent = {
        type: blockContent.type ?? '25px',
        value: blockContent.value ?? 0,
      };
    },
    spacerClear: () => initialState,

    spacerUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    spacerUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    spacerUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { spacerStore, spacerClear, spacerUpdateIsLoading, spacerUpdateIsActive, spacerUpdateBlockContent } = spacerSlice.actions;

export const selectSpacerIsLoading = (state) => state.spacer.isLoading;

export const selectSpacerId = (state) => state.spacer.id;
export const selectSpacerUID = (state) => state.spacer.uid;
export const selectSpacerSID = (state) => state.spacer.sid;

export const selectSpacerBlockContent = (state) => state.spacer.blockContent;

export default spacerSlice.reducer;
